module.exports = new __parcel__URL__("search-empty-state.bd1585ad.svg").toString();